import "@hotwired/turbo-rails"
import * as ActionCable from "@rails/actioncable"
import "../controllers"

// Create ActionCable consumer and expose globally for controllers
window.Cable = ActionCable.createConsumer()
